import { CircularProgress } from '@mui/material';

export default function LoadingScreen() {

    return (
        <div className="position-absolute top-50 start-50 translate-middle">
            <CircularProgress />
        </div>
    )
}